import Animation from './animation'
import * as d3 from 'd3-selection'
import { scaleLinear } from 'd3-scale'

class HierarchyUpAnimation extends Animation {

  match (serie) {
    let match = false

    // Calculated breakdown indicating we're showing a bunch of series without a breakdown
    if (this.chart.layout.breakdown.calculated && this.series.size()) {
      // If series are being removed and we're removing all of the series
      if (this.exitingSeries.size() && this.previous.series.size() === this.exitingSeries.size()) {
        // Do any of the exiting series have a parentId
        // Do the new series have a parentId that matches one of the series that's leaving?
        let parentId = this.exitingSeries.selection().data()[0].parentId // We're grabbing the first one, but they should all be the same
          , enteringIds = this.series.selection().data().map(serie => serie.id)

        if (parentId && enteringIds.indexOf(parentId) !== -1) {
          this.parentId = parentId
          match = true
        }
      }
    }

    return match
  }

  animate (serie, entering, selection, merged, exiting) {
    let exitingSerie = this.exitingSeries.filter(f => f.id === serie.id)
      , self = this

    if (exitingSerie.size()) {
      // Find the entering serie that matches the parent id
      let parent = this.series.filter(serie => serie.id === this.parentId).selection()
        , parentSlice = parent.selectAll('use').datum().slice
        , scale = scaleLinear().domain([0, 360 * Math.PI / 180 ])
                               .range([parentSlice.startAngle, parentSlice.endAngle])

      merged.call(this.fadeOut, true)
            .select(function (d) {
              let path = d3.select(`#${d.pathUid.id}`)

              path.transition()
                  .duration(self.timing.duration)
                  .attrTween('d', self.arcTweener(path.node(), {
                    startAngle: scale(path.node()._current.startAngle),
                    endAngle: scale(path.node()._current.endAngle)
                  }))
              return this
            })

      exitingSerie.selection().raise() // Put the exiting series on top
    } else {
      if (serie.id === this.parentId) {
        merged.select(d => {
                d3.select(`#${d.pathUid.id}`)
                  .each(function () {
                    this._current = {
                      startAngle: 0,
                      endAngle: 360 * Math.PI / 180
                    }
                  })
              })
      }
      merged.call(this.fadeIn, this.styles)
            .call(this.tweenPath, this.arcTweener)
    }
  }

}

export default HierarchyUpAnimation
